import { useCookies } from '@vueuse/integrations/useCookies'
import type { CookieSetOptions } from 'universal-cookie'

export function useAutoRefresh() {
	const cookies = useCookies(['auto_refresh'])
	const cookieSetOptions = <CookieSetOptions>{
		path: '/',
		expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7),
	}
	const { current } = useRoute()
	const autoRefresh = computed(() => cookies.get('auto_refresh'))
	const refreshRoutes = ['event.show', 'event.following', 'event.files']

	// 30 seconds
	const refreshInterval = 1000 * 30

	setInterval(() => {
		if (!current.value || !refreshRoutes.includes(current.value)) {
			return
		}

		if (!autoRefresh.value) {
			return
		}

		router.reload()
	}, refreshInterval)

	if (!cookies.get('auto_refresh')) {
		cookies.set('auto_refresh', false, cookieSetOptions)
	}

	const toggleAutoRefresh = () => {
		cookies.set('auto_refresh', !cookies.get('auto_refresh'), cookieSetOptions)
	}

	return {
		toggleAutoRefresh,
		autoRefresh,
	}
}
